<template>
  <div>
    <MyBreadcrumb
      v-if="detail.productType!==3"
      :breadcrumb-list="[
        {text:'应用列表',to:'/app/market/index'},
        {text:'应用详情',to:''}
      ]"
    ></MyBreadcrumb>
    <!-- 数据加载中显示骨架屏 -->
    <skeleton v-if="detailLoading"></skeleton>
    <Form
      v-else
      ref="form"
      :model="form.params"
      label-position="left"
      inline
      class="page-content"
    >
      <!-- 顶部 -->
      <div class="product-top">
        <img
          class="product-img"
          :src="detail.productImage"
        >
        <div class="product-top-right">
          <h4 class="product-name">
            {{ detail.saleName }}
            <span
              v-if="detail.serviceEnd"
              :class="['expire-time',{'expire-time-red':detail.serviceEnd<nowDate}]"
            >即将于 {{ detail.serviceEnd }} 到期</span>
          </h4>
          <div class="product-intro">
            {{ detail.productMemo }}
          </div>
          <div class="info-item">
            <span>适用系统：</span>
            <span
              v-for="(item,index) in detail.orderSourceList"
              :key="index"
              class="sku-item item-orderSource-text"
            > {{ item }}</span>
          </div>
          <div
            v-for="(item,index) in skuInfo.productPropertyList"
            :key="index"
            class="info-item"
          >
            <div v-if="item.propertyName==='版本'">
              <span>订购服务：</span>
              <span>
                <span
                  v-for="(sitem,sindex) in item.propertyList"
                  :key="sindex"
                  :class="['sku-item',{select:sindex===item.select}]"
                  @click="skuSelect(index,sindex)"
                >{{ sitem.value }}{{ sitem.unit }}</span>
              </span>
            </div>
            <div v-else-if="item.propertyName==='服务周期'">
              <span>{{ item.propertyName }}：</span>
              <span>
                <span
                  v-for="(sitem,sindex) in item.propertyList"
                  :key="sindex"
                  :class="['sku-item',{select:sindex===item.select}]"
                  @click="skuSelect(index,sindex)"
                >
                  <span> {{ sitem.value }}{{ sitem.unit }}</span>
                <!-- <span> ￥{{ selectSkuItem.salePrice | moneyFix }}</span> -->
                <!-- <span> ￥{{ versionPriceObj[selectSkuItem.propertyValues['版本']][sitem.value+sitem.unit] | moneyFix }}</span> -->
                </span>
              </span>
            </div>
            <!-- <div v-else-if="item.propertyName==='店铺数量'">
              <span>{{ shopNum.propertyName }}：</span>

              <span
                :class="['sku-item']"
              >{{ shopNum.propertyList[shopNum.select].value }}{{ shopNum.propertyList[shopNum.select].unit }}</span>
              </span>
            </div> -->
            <div v-else>
              <span>{{ item.propertyName }}：</span>
              <span>
                <span
                  v-for="(sitem,sindex) in item.propertyList"
                  :key="sindex"
                  :class="['sku-item',{select:sindex===item.select}]"
                  @click="skuSelect(index,sindex)"
                >{{ sitem.value }}{{ sitem.unit }}</span>
              </span>
            </div>
          </div>
          <!-- <div class="info-item">
          <span>服务周期：</span>
          <span class="sku-item">
            {{ detail.versionList[version.select].servicePeriod }}
          </span>
        </div> -->
          <div class="info-item">
            <span>服务价格：</span>
            <span>
              <!-- 设置规格时 -->
              <span
                v-if="selectSkuItem.skuId"
                class="info-price"
              >
                ￥{{ selectSkuItem.salePrice| moneyFix }}
              </span>
              <!-- 没设置规格时 -->
              <span
                v-else
                class="info-price"
              > ￥{{ skuInfo.salePrice| moneyFix }}</span>
            </span>
          </div>

          <div
            v-if="isShowAccount"
            class="info-item"
          >
            <FormItem

              prop="accountNo"
              :rules="form.rules.accountNo"
            >
              <span>系统账号：</span>
              <Select
                v-model="form.params.accountNo"
                style="display: inline-block; width: 200px;"
                transfer
              >
                <Option
                  v-for="(item,index) in accountNoList"
                  :key="index"
                  :value="item.accountNo"
                >
                  {{ item.accountName }}
                </Option>
              </Select>
            </FormItem>
            <FormItem
              v-if="appProductList.length>1"
              prop="appProductId"
              :rules="[{ required: true,type:'number', message: '请选择产品', trigger: 'blur' },]"
            >
              <Select
                v-model="form.params.appProductId"
                style="display: inline-block; width: 200px;"
                transfer
                placeholder="请选择产品"
              >
                <Option
                  v-for="(item,index) in appProductList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.productName }}
                </Option>
              </Select>
            </FormItem>
          </div>
          <div class="order-bottom">
            <Button
              style="border-radius: 0;"
              type="primary"
              :disabled="detail.productStatus!==1&&detail.productType!==3"
              :loading="form.submitLoading"
              @click="form.on.submit"
            >
              购买应用
            </Button>
            <template v-if="!isDistributionChannels">
              <div
                v-if="fromApplication"
                class="balance-box"
              >
                <span
                  class="balance-text"
                >店铺余额为{{ accountBalance.capitalAmount||'0.00' }}，您可以选择充值店铺余额。</span>
                <Button
                  type="text"
                  size="small"
                  class="balance-recharge"
                  @click="goRecharge"
                >
                  前往充值
                </Button>
              </div>
              <span
                v-if="!fromApplication"
                class="exchange-box"
              >
                <span class="exchange-text"> 我有激活码，我要兑换服务 </span>
                <Button
                  type="text"
                  :disabled="detail.productStatus!==1"
                  class="exchange-btn"
                  @click="goExchange"
                >去兑换</Button>
              </span>
            </template>
          </div>
        </div>
      </div>
      <!-- 选项卡 -->
      <div class="tab-box">
        <div class="tab-top">
          <span class="tab-name">应用详情</span>
        </div>
        <div
          class="rich-text"
          v-html="detail.productDesc"
        ></div>
      </div>

      <!-- <Tabs
        type="card"
        class="tab-box"
      >
        <TabPane label="应用详情">
        </TabPane>
      </Tabs> -->
    </Form>

    <DeveloperInformation
      v-if="developerInfoVO"
      :developer-info-v-o="developerInfoVO"
    />
  </div>
</template>
<script>
import moment from 'moment';
import skeleton from './components/skeleton';
// 配置文件
import configEnv from '@/config';
import {inIframe} from '@/common/createMicroApp/utils';
export default {
  components: {
    skeleton,
    DeveloperInformation: ()=>import('./components/developerInformation.vue'),
  },
  data(){
    return {
      inIframe,
      form: {
        submitLoading: false,
        params: {
          accountNo: '',
          // appProductId: '',
        },
        rules: {
          accountNo: [
            {
              required: false,
              // message: '请选择系统账号',
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请选择系统账号！'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
        on: {
          submit: async ()=>{
            const valid = await this.$refs.form.validate();
            if (!valid){
              return;
            }
            const {
              productCode,
              unifiedEntityId,
              pid,
            } = this.$route.query;
            let {
              accountNo,
            } = this.form.params;
            const {
              appProductId,
            } = this.form.params;
            if (this.fromApplication||this.isDistributionChannels){
              // 抖音团购 新增租户信息 隐藏选择系统账号 默认选择新增租户返回的accountNo
              accountNo = this.tenantInfo.accountNo;
            }
            const {productType} = this.detail;
            // productType是3 接口应用 才有 unifiedEntityId, pid,
            if (productType===3){
              // 接口应用跳转去购买页面接口校验
              const url = '/paycenter-charge/api/worktable/order/accountCheck';
              const params = {
                pid,
                unifiedEntityId,
              };
              this.form.submitLoading = true;
              const checkRes= await this.$http.postJson(url,params);
              this.form.submitLoading = false;
              if (!checkRes.data){
                this.$Message.warning(checkRes.message||'开发者账户信息不存在');
                return;
              }


            }
            this.$router.push({
              path: '/app/order/index',
              query: {
                productCode,
                // corpCode,
                // corpName,
                accountNo,
                skuId: this.selectSkuItem.skuId,
                unifiedEntityId,
                pid,
                appProductId,
              },
            });

          },
        },
      },
      detailLoading: true,
      nowDate: moment().add(30,'days').format('YYYY-MM-DD'),
      // // 店铺数量
      // shopNum: {},
      // 规格信息
      skuInfo: {
        skuItemList: [],
      },
      // 每个版本对应的服务周期的价格
      // versionPriceObj: {},
      // 查找匹配的规格
      selectSkuItem: {
        propertyValues: {},
      },
      detail: {
        versionList: [
          {},
        ],
      },
      accountNoList: [],
      accountNo: '',
      // 店铺余额
      accountBalance: {},
      // 抖音团购 新增租户信息
      tenantInfo: {},
      // appProductList: [],
    };
  },
  computed: {
    developerInfoVO(){
      return this.detail?.developerInfoVO??null;
    },
    // 是否是智游宝B端 抖音团购
    fromApplication(){
      const {
        from,
      } = this.$route.query;
      return from==='vapplication';
    },
    //是否是商城分销渠道
    isDistributionChannels(){
      const {
        from,
      } = this.$route.query;
      return from==='distributionChannels';
    },
    isShowAccount(){
      //应用市场来源隐藏
      if (this.isDistributionChannels){
        return false;
      }

      // 抖音团购隐藏系统账号
      if (this.detail.hideAccountForm === 1){
        return false;
      }
      // 登录时并且不是接口应用时
      return this.$store.state.user.userInfo.token&&this.detail.productType!==3;
    },
    appProductList(){
      const {accountNoList} = this;
      const {accountNo} = this.form.params;
      if (!accountNo){
        return [];
      }
      return accountNoList.find(ele=>ele.accountNo===accountNo).productList;
    },
  },
  async created(){
    //抖音团购专用
    await this.applicationDouyin();
    // 获取详情
    this.getDetail();
    // 获取规格
    this.getSkuInfo();
    // 获取系统账号列表
    this.getAccountNo();

  },
  mounted(){
    // 头部主体变化事件绑定
    // 防止多次监听
    // this.$root.$off('on-corp-change');
    this.$root.$on('on-corp-change', () => {
      // 重新获取已订购的产品
      this.form.params.accountNo = '';
      this.getAccountNo();
    });

    const {
      from,
    } = this.$route.query;
    if (from==='distributionChannels'){
      sessionStorage.setItem('pageFrom','distributionChannels');
    }


  },
  beforeDestroy(){
    this.$root.$off('on-corp-change');
  },
  methods: {
    // 抖音团购专用
    async applicationDouyin(){
      if (!(this.fromApplication||this.isDistributionChannels)){
        return;
      }
      //新增租户
      await this.addTenant();
      // 店铺余额
      this.queryAccountBalance();
    },

    async queryAccountBalance(){
      const {
        unifiedEntityId,
        corpCode,
        shopId,
        productCode,
        // orderSource,
        from,
        syncAccount,
      } = this.$route.query;
      if (from==='vapplication'){
        // 智游宝B端 应用市场 抖音团购应用购买应用 新增租户
        const url = '/paycenter-charge/api/tenant/info/queryAccountBalance';
        const params = {
          unifiedEntityId,
          corpCode,
          shopId,
          productCode,
          // orderSource,
          syncAccount,
        };
        const res = await this.$http.get(url,params);
        this.accountBalance = res?.data||{};
      }
    },
    // 抖音团购充值
    goRecharge(){
      const {baseURL} = configEnv;
      window.location.href = `${baseURL}/inset/storeBalance/recharge?type=douyintuangou`;
      // const iframeUrl = encodeURIComponent(`${baseURL}/inset/storeBalance/recharge`);
      // window.open(`${lotsmallDomain}/manage/storeBalance?iframeUrl=${iframeUrl}`,'_blank');
    },
    // 新增租户 抖音团购专用
    async addTenant(){
      const {
        unifiedEntityId,
        corpCode,
        shopId,
        productCode,
        from,
      } = this.$route.query;
      if (['vapplication','distributionChannels'].includes(from)){
        // 智游宝B端 应用市场 抖音团购应用购买应用 新增租户
        const url = '/paycenter-charge/api/tenant/info/add';
        const params = {
          unifiedEntityId,
          corpCode,
          shopId,
          productCode,
        };
        const res = await this.$http.postJson(url,params);
        if (!res.success){
          this.$Message.warning(res.message||'请求接口失败');
          return;
        }
        this.tenantInfo = res.data;
        // 重置corpCode
        this.$store.commit('setUserInfo',{corpCode: res.data.corpCode,corpName: res.data.corpName});
      }
    },
    // 获取系统账号列表
    getAccountNo() {
      if (this.from==='vapplication'){
        // 抖音团购 无需系统账号
        return;
      }
      const {corpCode,token} = this.$store.state.user.userInfo;
      if (token && corpCode){
        const url = '/paycenter-charge/api/worktable/list/accountNo';
        const params = {
          productCode: this.$route.query.productCode,
          corpCode,
        };

        this.$http.get(url,params).then(res => {
          if (res.success) {
            this.accountNoList = res.data;
          } else {
            this.$Message.warning(res.message || '获取详情失败');
          }
        });
      }

    },
    // 获取详情
    getDetail() {
      const {corpCode} = this.$store.state.user.userInfo;
      const url = '/paycenter-charge/api/facade/product/view';
      const params = {
        productCode: this.$route.query.productCode,
        corpCode,
      };
      this.detailLoading = true;
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.detailLoading = false;
          this.detail = res.data;
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 获取规格
    getSkuInfo() {
      // const url = '/paycenter-charge/api/facade/product/skuInfo';
      const url = '/paycenter-charge/api/worktable/skuInfo';
      const params = {
        productCode: this.$route.query.productCode,
      };
      this.$http.get(url,params).then(res => {
        if (res.success) {
          const {productPropertyList} = res.data;
          // 获取店铺数量
          if (productPropertyList && productPropertyList.length){
            productPropertyList.forEach(ele=>{
              ele.select = 0;
              // 原始值，规格过滤用
              ele.orignPropertyList = [...ele.propertyList];
              // if (ele.propertyName==='店铺数量'){
              //   this.shopNum = ele;
              // }
            });
            // this.shopNum = productPropertyList.find(ele=>ele.propertyName==='店铺数量');
          }
          this.skuInfo = {
            ...res.data,
            productPropertyList,
          };

          // 设置初始选择的值
          this.setHidePropertyList(-1);

          // 商品规格价格计算
          this.getSkuPrice();
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 去兑换
    goExchange(){
      // 检查是否认证
      const {corpList,token} = this.$store.state.user.userInfo;
      if (token && (!corpList||!corpList.length)){
        // 弹出去认证弹框
        this.$root.$emit('show-auth-modal');
        return;
      }
      const {
        productCode,
        unifiedEntityId,
        pid,
      } = this.$route.query;
      // productType是3 接口应用 才有 unifiedEntityId, pid,
      const {productType} = this.detail;
      const {href} = this.$router.resolve({
        path: '/standardProduct/exchange/index',
        query: {
          productCode,
          from: 'appDetail',
          productType,
          unifiedEntityId,
          pid,
          // corpCode,
          // corpName,
        },
      });
      // window.open(href,'_blank');
      window.location.href = href;
    },

    // 规格选择
    skuSelect(index,sindex){
      const item = this.skuInfo.productPropertyList[index];

      // if (item.propertyName==='服务周期'){
      //   this.$set(this.shopNum,'select',sindex);
      // }
      this.$set(item,'select',sindex);

      // 规格明细中隐藏（needShow===0）的规格不显示
      this.setHidePropertyList(index,sindex);

      // 如果规格全部选择了，则计算价格
      this.getSkuPrice();
    },
    setHidePropertyList(index){
      const {productPropertyList} = this.skuInfo;
      if (!productPropertyList){
        return;
      }
      const totalLength = productPropertyList.length;
      if (index>=totalLength){
        return;
      }

      // 获取已经选中的规格
      const hasSelectPropertyValues = {};
      let i=0;
      while (i<=index){
        const item = this.skuInfo.productPropertyList[i];
        if (item.propertyName!=='店铺数量'){
          const propertyItem = item.propertyList[item.select];
          hasSelectPropertyValues[item.propertyName] = `${propertyItem.value}${propertyItem.unit||''}`;
        }
        i++;
      }
      // 设置初始选择的值时 index=-1
      let k = totalLength-index;
      if (index<0){
        k = totalLength;
      }
      let j = index+1;
      while (j<k){
        const item = this.skuInfo.productPropertyList[j];
        if (item.propertyName!=='版本'){
          item.select = 0;
        }
        if (item.propertyName!=='店铺数量'){
          item.propertyList = item.orignPropertyList.filter(ele=>{
          // 查找选择的规格是否显示
            const propertyValuesItem = {
              ...hasSelectPropertyValues,
            };
            propertyValuesItem[item.propertyName] = `${ele.value}${ele.unit||''}`;
            let isShow = false;
            this.skuInfo.skuItemList.find(skuItem=>{
              if (skuItem.needShow===1){
                const propertyValues = JSON.parse(skuItem.propertyValues);
                let isFind = true;
                Object.keys(propertyValuesItem).forEach(key=>{
                  if (propertyValuesItem[key]!==propertyValues[key] ){
                    isFind = false;
                  }
                });
                if (isFind){
                  isShow = true;
                }
              }
              return isShow;
            });

            return isShow;
          });
          const propertyItem = item.propertyList[item.select];
          // 添加选中的项
          hasSelectPropertyValues[item.propertyName] = `${propertyItem.value}${propertyItem.unit||''}`;

        }
        j++;
      }

    },
    // 查找匹配的规格
    getSkuPrice(){
      const propertyObj = {};
      const {productPropertyList,skuItemList} = this.skuInfo;
      if (productPropertyList && productPropertyList.length){
        productPropertyList.forEach((ele) => {
          const {propertyName,propertyList,select} = ele;
          // propertyObj[`${propertyName}`] = propertyList[select].value+(propertyList[select].unit||'');
          if (propertyName!=='店铺数量'){
            propertyObj[propertyName] = propertyList[select].value+(propertyList[select].unit||'');

          }
        });

      }
      // 每个版本对应的服务周期的价格
      // const versionPriceObj = {};
      if (skuItemList){
        skuItemList.forEach(ele=>{
          const propertyValues = JSON.parse(ele.propertyValues);
          let isFind = true;
          Object.keys(propertyObj).forEach(key=>{
            if (propertyObj[key]!==propertyValues[key]){
              isFind = false;
            }
          });
          // 查找匹配的规格
          if (isFind){
            this.selectSkuItem = {
              ...ele,
              propertyValues,
            };
          }
        // // 如果服务周期和版本存在 查找版本下每个服务周期的价格
        // const versionName =propertyValues['版本'];
        // const serverTimeName = propertyValues['服务周期'];
        // if (versionName && serverTimeName){
        //   if (versionPriceObj[versionName]){
        //     versionPriceObj[versionName][serverTimeName]=ele.salePrice;
        //   } else {
        //     versionPriceObj[versionName]={
        //       [serverTimeName]: ele.price,
        //     };
        //   }
        // }
        });

      }
      // console.log(versionPriceObj);
      // this.versionPriceObj = versionPriceObj;
    },
  },
};
</script>
<style lang="less" scoped>

.product-top {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 30px;
  display: flex;
  // align-items: center;
  .product-img {
    // float: left;
    width: 304px;
    height: 214px;
    flex-shrink: 0;
  }
  .expire-time {
    color: #999;
    font-size: 12px;
    padding: 5px 0;
    &-red {
      color: #f00;
    }
  }
  .product-top-right {
    // float: left;
    padding-left: 20px;
  }
  .product-name {
    font-size: 16px;
    color: #333;
    padding-bottom: 5px;
  }
  .product-intro {
    font-size: 13px;
    color: #999;
    padding: 5px 0;
  }
  .order-bottom {
    margin-top: 10px;
  }
  .info-item {
    margin: 15px 0;
    /deep/ .ivu-form-item-label {
      font-size: 14px;
      padding: 10px 0;
      // height: unset;
    }
  }
  .info-price {
    font-size: 16px;
    color: #f00;
  }
  .exchange-box {
    position: absolute;
    right: 30px;
    bottom: 10px;
    // margin-left: 5px;
    font-size: 12px;
    .exchange-text {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
    .exchange-btn {
      vertical-align: middle;
      // margin-left: 5px;
      cursor: pointer;
      color: #409eff;
      padding: 0;
    }
  }
  .sku-item {
    font-size: 12px;
    color: #666;
    border: 1px solid #e0e0e0;
    padding: 3px 10px;
    // border-radius: 5px;
    margin-bottom: 20px;
    position: relative;
    margin-right: 10px;
    cursor: pointer;
    &.select {
      border: 1px solid #409eff;
      background: #eef5fb;
      &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-bottom: 8px solid #409eff;
        border-left: 8px solid transparent;
        right: -1px; // 解决像素偏差问题
        bottom: -1px;// 解决像素偏差问题
      }
    }
  }
  .item-orderSource-text {
    font-size: 12px;
    color: #666;
    border: 0;
    padding: 0;
    margin-right: 5px;
  }
}
.tab-box {
  background-color: #fff;
  padding: 20px;
  .tab-top {
    margin-bottom: 20px;
    border-bottom: 1px solid #dcdee2;
  }
  .tab-name {
    display: inline-block;
    // color: #5e7ce0;
    // padding: 5px 0;
    border: 1px solid #dcdee2;
    border-bottom: 1px solid #fff;
    // font-size: 16px;
    // font-weight: bold;
    color: #5e7ce0;
    // height: 32px;
    // line-height: 32px;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: -1px;
    // background-color: #fff;
  }
}
// 店铺余额
.balance-box{
  display: inline-block;
  margin-left: 10px;
  .balance-text{
    display: inline-block;
    font-size: 14px;
    color:#999;
    vertical-align: middle;
  }
  .balance-recharge{
    color:#4772fc;
  }
}
</style>
